import { atom } from 'jotai'
import { ApiKey } from 'types/apiKeys'

export const editApiKeyDataAtom = atom<ApiKey>({} as ApiKey)
editApiKeyDataAtom.debugLabel = 'edit-api-key-data'
